const generateTimeValues = (count: number) => Array(count).fill(null).map((_, index) => {
    return index < 10 ? `0${index}` : `${index}`;
});

export const timePickerSettings = {
    hours: generateTimeValues(24),
    minutes: generateTimeValues(60),
};
